module.exports = __webpack_public_path__ + "static/media/avatar-default.f333f77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatar-default.png
// module id = 1242
// module chunks = 0